import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { FileText, Loader2, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { API, errMsg, rupiah, STATUS_META } from "@/lib/api";

export default function TrackPage() {
  const [code, setCode] = useState("");
  const [wa, setWa] = useState("");
  const [res, setRes] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(""); setRes(null);
    try {
      const { data } = await axios.get(`${API}/orders/track/${encodeURIComponent(code.trim())}`, { params: { wa } });
      setRes(data);
    } catch (err) {
      setError(errMsg(err, "Pesanan tidak ditemukan"));
    } finally { setLoading(false); }
  };
  const meta = res && STATUS_META[res.status];

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-16" data-testid="track-page">
      <h1 className="font-display font-black uppercase italic text-4xl sm:text-5xl">Cek <span className="text-[#FF5A00]">Pesanan</span></h1>
      <form onSubmit={submit} className="mt-8 grid sm:grid-cols-[1fr_1fr_auto] gap-3 items-end">
        <div className="space-y-2"><Label>Kode Pesanan</Label><Input required value={code} onChange={(e) => setCode(e.target.value)} placeholder="LJ-XXXXXX" data-testid="track-code-input" className="h-12 bg-[#121212] uppercase" /></div>
        <div className="space-y-2"><Label>Nomor WhatsApp</Label><Input required value={wa} onChange={(e) => setWa(e.target.value)} placeholder="08xxxxxxxxxx" data-testid="track-wa-input" className="h-12 bg-[#121212]" /></div>
        <button type="submit" data-testid="track-submit-btn" className="h-12 px-6 bg-[#FF5A00] hover:bg-[#E04F00] active:scale-95 transition-[background-color,transform] duration-150 flex items-center gap-2 font-display font-bold uppercase text-lg">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Search className="w-5 h-5" />} Cek
        </button>
      </form>
      {error && <p data-testid="track-error" className="mt-6 text-red-400">{error}</p>}
      {res && (
        <div data-testid="track-result" className="mt-8 border border-white/10 bg-[#121212] p-6">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p className="font-display font-black text-3xl">{res.order_code}</p>
            <span data-testid="track-status" className={`border px-3 py-1 text-sm font-semibold ${meta?.cls}`}>{meta?.label}</span>
          </div>
          <p className="mt-3 text-neutral-300">{res.athlete_name}{res.bib_number && ` (BIB ${res.bib_number})`} · {res.event_count} mata lomba · {rupiah(res.total)}</p>
          <ul className="mt-3 text-sm text-neutral-400 list-disc pl-5">{res.events.map((e, i) => <li key={i}>{e.name} ({e.day})</li>)}</ul>
          {res.admin_note && <p className="mt-4 text-sm border-l-2 border-[#FF5A00] pl-3">Catatan admin: {res.admin_note}</p>}
          {res.receipt_token && (
            <Link to={`/kuitansi/${res.receipt_token}`} data-testid="track-receipt-link" className="mt-5 inline-flex items-center gap-2 bg-[#FF5A00] hover:bg-[#E04F00] px-5 py-2.5 font-display font-bold uppercase transition-colors">
              <FileText className="w-4 h-4" /> Lihat Kuitansi
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
